import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { TBResponse } from '@construction/models/wbs-elements.model';

@Injectable({ providedIn: 'root' })
export class PresignedImageApiService {
  private http = inject(HttpClient);

  public getPresignedUrlImage(imageId: string) {
    const url = `${environment.apiUrl}/${environment.apiVersion}/resources/images/${imageId}/url/`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.get<TBResponse<{ url: string }>>(url, { headers }).pipe(
      map((res) => {
        const imageUrl = res.data.url;

        return { url: environment.s3ResourcesUrlRootCF ? this.replaceUrlHost(imageUrl) : imageUrl };
      }),
      catchError((error) => {
        console.error('Failed to get requested resource with id: ', imageId, ' Error: ', error);

        return of({ url: '' });
      }),
    );
  }

  public getPresignedThumbnailUrl(imageId: string) {
    const url = `${environment.apiUrl}/${environment.apiVersion}/resources/images/${imageId}/thumbnail/url/`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.get<TBResponse<{ url: string }>>(url, { headers }).pipe(
      map((res) => {
        const imageUrl = res.data.url;

        return { url: environment.s3ResourcesUrlRootCF ? this.replaceUrlHost(imageUrl) : imageUrl };
      }),
      catchError((error) => {
        console.error('Failed to get thumbnail for resource with id: ', imageId, ' Error: ', error);

        return of({ url: '' });
      }),
    );
  }

  public getPresignedUrlFromExistingOrtho(constructionProjectId: string, imageId: string) {
    const url = `${environment.apiUrl}/${environment.apiVersion}/construction_projects/${constructionProjectId}/drone_orthos/${imageId}/presigned_url/`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.get<TBResponse<{ url: string }>>(url, { headers }).pipe(map((res) => res.data));
  }

  public getPresignedUrlFromNewOrtho(constructionProjectId: string, url: string) {
    const params = new HttpParams({ fromObject: { url } });
    const apiUrl = `${environment.apiUrl}/${environment.apiVersion}/construction_projects/${constructionProjectId}/drone_orthos/presigned_url/`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.get<TBResponse<{ url: string }>>(apiUrl, { params, headers }).pipe(map((res) => res.data));
  }

  private replaceUrlHost(originalUrl: string) {
    const url1 = new URL(originalUrl);
    const url2 = new URL(environment.s3ResourcesUrlRootCF);
    url1.hostname = url2.hostname;

    return url1.toString();
  }
}
